// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fbdd658c","239":"cb02f229","453":"75648a8a","455":"827f43ce"}[chunkId] + ".chunk.js";
};